import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from '@/hooks/useAuthState';
import { PhotoBoothPage } from '@/pages/PhotoBoothPage';
import { AdminDashboardPage } from '@/pages/AdminDashboardPage';
import { BillingPage } from '@/pages/BillingPage';
import { CheckoutSuccessPage } from '@/pages/CheckoutSuccessPage';
import { LoginPage } from '@/pages/LoginPage';
import { LandingPage } from '@/pages/LandingPage';
// import { PhotoStripTestPage } from '@/pages/PhotoStripTestPage';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { ScrollToTop } from '@/components/ScrollToTop';

function App() {
  const { loading } = useAuthState();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/test-strip" element={<PhotoStripTestPage />} /> */}

        {/* Protected routes */}
        <Route
          path="/booth"
          element={
            <ProtectedRoute>
              <PhotoBoothPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiresPassword>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <ProtectedRoute requiresSubscription={false}>
              <BillingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout/success"
          element={
            <ProtectedRoute requiresSubscription={false}>
              <CheckoutSuccessPage />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
